module.exports = __webpack_public_path__ + "static/media/startLeftDark.d2aea1ef.svg";